export const TestRow = (props: any) => {
    return <div className="row m-0 p-3 border-bottom">{props.children}</div>
}